import { render } from "./SizeSelectionModal.vue?vue&type=template&id=cc67e5ca&scoped=true"
import script from "./SizeSelectionModal.vue?vue&type=script&lang=js"
export * from "./SizeSelectionModal.vue?vue&type=script&lang=js"

import "./SizeSelectionModal.vue?vue&type=style&index=0&id=cc67e5ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc67e5ca"]])

export default __exports__